import { useEffect } from "react";

export default function useHideShowDropDown(ref, fun) {
  useEffect(() => {
    try {
      let listener = (e) => {
        if (!ref.current || ref?.current?.contains(e.target)) {
          return;
        }
        fun();
      };

      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);

      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    } catch (error) {
      console.log(error);
    }
  }, [ref]);
}
